import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import {
  reactive,
  onMounted,
  onUnmounted,
  getCurrentInstance,
  inject
} from "vue";
import { useGlobalSearch } from "@/composable/useGlobalSearch";
import { useI18n } from "vue-i18n";

// Import modals
import CreateOrganizationModel from "@/components/modal/CreateOrganizationModel.vue";
import CreateEntitlementModal from "@/components/modal/CreateEntitlementModal.vue";
import BreadcrumbSettingsModal from "@/components/modal/BreadcrumbSettingsModal.vue";
import { callCreateOrganization } from "@/api/identity";
import { useRouter } from "vue-router";

// Initialize services

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { registerActionEmitter } = useGlobalSearch();
const instance = getCurrentInstance();
const toasts = instance?.appContext.config.globalProperties.$toasts;
const { t } = useI18n();
const handleError = inject("handleError");
const router = useRouter();

// Component state
const state = reactive({
  modals: {
    createOrganization: false,
    createEntitlement: false,
    breadcrumbSettings: false
  }
});

// Handle action execution
const executeAction = (action: string) => {
  switch (action) {
    case "create-organization":
      state.modals.createOrganization = true;
      break;
    case "create-entitlement":
      state.modals.createEntitlement = true;
      break;
    case "breadcrumb-settings":
      state.modals.breadcrumbSettings = true;
      break;
    default:
      console.warn("Unknown action:", action);
  }
};

// Close specific modal
const closeModal = (modalName: keyof typeof state.modals) => {
  state.modals[modalName] = false;
};

// Action handlers
const handleCreateOrganization = async (organizationData: any) => {
  try {
    const response = await callCreateOrganization({
      name: organizationData.name || organizationData
    });
    state.modals.createOrganization = false;
    toasts?.info(t("organizations.creationSuccess"));
    const newOrgId = (response as any)?.data?.id;
    if (newOrgId) {
      router.push({ path: `/admin/identity/organizations/${newOrgId}` });
    }
  } catch (error) {
    (handleError as any)?.(error);
  }
};

// Register action emitter on mount
onMounted(() => {
  registerActionEmitter(executeAction);
});

onUnmounted(() => {
  registerActionEmitter(() => {
    // Empty action emitter for cleanup
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(CreateOrganizationModel, {
      isOpen: _unref(state).modals.createOrganization,
      onCancel: _cache[0] || (_cache[0] = ($event: any) => (closeModal('createOrganization'))),
      onCreate: handleCreateOrganization
    }, null, 8, ["isOpen"]),
    (_unref(state).modals.createEntitlement)
      ? (_openBlock(), _createBlock(CreateEntitlementModal, {
          key: 0,
          "is-open": _unref(state).modals.createEntitlement,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (closeModal('createEntitlement')))
        }, null, 8, ["is-open"]))
      : _createCommentVNode("", true),
    _createVNode(BreadcrumbSettingsModal, {
      "model-value": _unref(state).modals.breadcrumbSettings,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (closeModal('breadcrumbSettings')))
    }, null, 8, ["model-value"])
  ]))
}
}

})